import React, { useEffect, useState } from 'react';
import { AlertTriangle, LogOut } from 'lucide-react';

const DuplicateLoginModal = ({ isOpen, onClose, onLogout }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
    }
  }, [isOpen]);

  const handleLogout = () => {
    setIsVisible(false);
    setTimeout(() => {
      onClose();
      onLogout();
    }, 300);
  };

  if (!isOpen) return null;

  return (
    <div 
      className={`fixed inset-0 z-50 flex items-center justify-center p-4 transition-all duration-300 ${
        isVisible ? 'bg-black/50 backdrop-blur-sm' : 'bg-black/0'
      }`}
    >
      <div 
        className={`bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden transform transition-all duration-300 ${
          isVisible ? 'scale-100 opacity-100' : 'scale-95 opacity-0'
        }`}
      >
        {/* Header with gradient */}
        <div className="bg-gradient-to-r from-amber-500 to-orange-500 p-6 text-white">
          <div className="flex items-center justify-center mb-3">
            <div className="bg-white/20 backdrop-blur-sm p-3 rounded-full">
              <AlertTriangle className="w-8 h-8" />
            </div>
          </div>
          <h2 className="text-2xl font-bold text-center">
            Session Conflict Detected
          </h2>
        </div>

        {/* Content */}
        <div className="p-6">
          <p className="text-gray-700 text-center mb-2 text-lg">
            Your account is already logged in on another device or browser.
          </p>
          <p className="text-gray-500 text-center text-sm mb-6">
            For security reasons, you'll be logged out from this session.
          </p>

          {/* Action Button */}
          <button
            onClick={handleLogout}
            className="w-full bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white font-semibold py-3 px-6 rounded-lg transition-all duration-200 flex items-center justify-center gap-2 shadow-lg hover:shadow-xl transform hover:scale-[1.02]"
          >
            <LogOut className="w-5 h-5" />
            Understood, Log Out
          </button>
        </div>

        {/* Decorative bottom border */}
        <div className="h-1 bg-gradient-to-r from-amber-500 via-orange-500 to-amber-500"></div>
      </div>
    </div>
  );
};

export default DuplicateLoginModal;